import { AtIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EmailSign = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <AtIcon size={Sizes[size]} {...rest} color={fill} />;
};

EmailSign.displayName = 'EmailSign';
